<div class="container-fluid">
  <div class="row mt-3 pt-1 pb-1 mb-1">
    <div class="col-12">
      <div class="d-flex flex-row justify-content-start">
        <div><i class="fal fa-thumbtack"></i></div>
        <div class="d-inline-block ml-2 mr-2">Tracked Projects / Branches</div>
      </div>
    </div>
  </div>

  <div *ngIf="!pipelines || pipelines.length === 0" class="row pipeline mt-1 pt-1 pb-1">
    <div class="col-12">No tracked projects / branches yet (or loading)</div>
  </div>

  <div class="row">
    <div *ngFor="let item of pipelines; even as even; odd as odd; index as index;"
         class="col-4 mt-1 pt-1 pb-1">
      <div [ngClass]="[item.pipeline.status, index % 3 != 0 ? 'ml' : '']" class="row pipeline">
        <div class="col-6">
          <div class="project">{{item.project?.name_with_namespace}}</div>
          <div class="ml-2 branch">
            <div class="d-inline-block mr-1"><i class="fal fa-code-branch"></i></div>
            <div class="d-inline-block">{{item.pipeline.ref}}</div>
            <div (mouseenter)="item.hover = true" (mouseleave)="item.hover = false" class="d-inline-block ml-3 track">
              <a (click)="untrack(item)" title="untrack branch"><i [ngClass]="[item.hover ? 'fas' : 'fal']"
                                                                   class="fa-trash"></i></a>
            </div>
          </div>
          <div class="ml-2 commit">
            {{item.commit?.title}}
          </div>
        </div>
        <div class="col-6">
          <div>
            <div class="d-inline-block started">{{item.pipeline.created_at | date: 'dd/MM HH:mm'}}</div>
            <div class="d-inline-block ml-2 user">{{item.commit?.author_name}}</div>
          </div>
          <div class="pipeline-link">
            <a class="mr-2" href="{{item.pipeline.web_url}}" target="_blank"><i
              class="fal fa-grip-lines mr-2"></i>{{item.pipeline.id}}</a>
            <a *ngIf="item.testReport && item.testReport.total.count > 0" href="{{item.pipeline.web_url}}/test_report"
               target="_blank"><i class="fal fa-tachometer-fastest ml-2 mr-2"></i>tests</a>
          </div>
        </div>
      </div>
    </div>

  </div>
</div>
